import { Banner } from "@aaa/muse-ds"
import React from 'react'
import PropTypes from 'prop-types';
export default function BannerErrorComponent(props){

    const hasError = props.error!=null && props.error!="";

    return <div>
        {hasError ? <Banner
        iconName="ui-circle-outline--error"
        message={props.error}
        color="red"
        iconColor="red"
        borderColor="red"
        showBanner
        showCloseButton
        closeAction={()=>props.close()}
        title={"Oops: An error has occurred!"}></Banner> : null }
    </div>
}
BannerErrorComponent.propTypes={
    error: PropTypes.string,
    close: PropTypes.func
}